
let imageList = [
    {
        src: require('../img/carousel/photo1.jpg'),
        alt: "5 members on a team"
    },
    {
        src: require('../img/carousel/photo2.jpg'),
        alt: "2 baby chicks lying on top of a computer while members chat on Zoom in the background"
    },
    {
        src: require('../img/carousel/photo3.jpg'),
        alt: "Members running toward the camera at a beach"
    },
    {
        src: require('../img/carousel/photo4.jpg' ),
        alt: "Members chillin on a patio"
    },
    {
        src: require('../img/carousel/photo5.jpg' ),
        alt: "Members at a rock climbing gym"
    },
];

export default imageList;